import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card swings in like a sign hung from a branch, and the last one swings away. */
export const treehouseCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const swing = isMobile ? 4 : 6;
  return {
    variants: {
      enter: (direction: CardDirection) => ({ opacity: 0, rotate: direction > 0 ? swing : -swing, y: -14, x: direction > 0 ? 24 : -24 }),
      center: { opacity: 1, rotate: 0, y: 0, x: 0 },
      exit: (direction: CardDirection) => ({ opacity: 0, rotate: direction > 0 ? -swing : swing, y: 10, x: direction > 0 ? -24 : 24 }),
    },
    transition: { duration: 0.95, ease: [0.3, 1.25, 0.5, 1] },
    style: { transformOrigin: '50% 0%' },
  };
};
